export default __webpack_public_path__ + "static/breezy-e85f5a32cde86671336b41fa42317fae.png";